import { MdCheckCircle, MdCancel, MdDeliveryDining } from 'react-icons/md';
import { AiOutlineLoading } from "react-icons/ai";
import { formatString } from '../utils/StringUtils';
import { ClientAvatarTooltip } from './reusables/clientAvatarTooltip';
import { formatDate } from '../utils/DateUtils';

export const OrderCard = ({ order, currentTab, hasPrep, onAction, permissions, loading }) => {
    let statusConfig = { bg: 'bg-gray-100', text: 'text-gray-600', label: order.status };
    if (order.status === 'PROCESSINGPAYMENT') statusConfig = { bg: 'bg-yellow-100', text: 'text-yellow-700', label: 'Pgto Pendente' };
    else if (order.status === 'COMPLETED') {
        if (hasPrep) statusConfig = { bg: 'bg-blue-100', text: 'text-blue-700', label: 'Em Preparo' };
        else statusConfig = { bg: 'bg-green-50 text-green-700', label: 'Retirada Balcão' };
    }
    else if (order.status === 'READYTODELIVER') statusConfig = { bg: 'bg-green-100', text: 'text-green-800', label: 'Pronto p/ Entrega' };
    else if (order.status === 'FINISHED') statusConfig = { bg: 'bg-gray-200', text: 'text-gray-600', label: 'Finalizado' };
    else if (order.status === 'CANCELED') statusConfig = { bg: 'bg-red-100', text: 'text-red-700', label: 'Cancelado' };

    return (
        <div className="bg-white rounded-xl shadow-sm border border-slate-200 hover:shadow-md transition-all flex flex-col h-full relative">
            <div className="p-4 border-b border-slate-100 flex justify-between items-start bg-slate-50/50 rounded-t-xl">
                <div className="flex flex-col w-full">
                    <div className="flex items-center justify-between mb-3">
                        <span className="font-mono text-xs font-bold text-gray-400">#{order.order_id}</span>
                        <span className="text-[10px] font-bold py-0.5 px-1.5 bg-slate-200 text-slate-600 rounded">
                            {formatDate(order.purchase_date)}
                        </span>
                    </div>

                    <div className="flex items-center justify-between">
                        <div className="flex flex-col">
                             <ClientAvatarTooltip clientString={order.client_id} />
                             {order.grade && <span className="text-[10px] font-bold text-gray-400 mt-1">{order.grade}</span>}
                        </div>
                        
                        <div className={`px-2 py-0.5 rounded text-[10px] font-bold uppercase border border-transparent ${statusConfig.bg} ${statusConfig.text}`}>
                            {statusConfig.label}
                        </div>
                    </div>
                </div>
            </div>

            <div className="p-4 flex-1">
                <p className="text-sm text-gray-600 line-clamp-4 leading-relaxed font-medium">
                    {formatString(order.items_list)}
                </p>
            </div>

            <div className="p-3 border-t border-slate-100 bg-slate-50/30 rounded-b-xl flex gap-2">
                {currentTab === 'toDeliver' && (
                    <>
                        <button onClick={() => onAction('finish', order)} disabled={!permissions.canChange || loading} className="flex-1 bg-green-500 hover:bg-green-600 text-white py-2 rounded-lg font-bold text-xs flex items-center justify-center gap-1 transition-colors shadow-sm disabled:opacity-50">
                            <MdCheckCircle size={16} /> Finalizar
                        </button>
                        <button onClick={() => onAction('cancel', order)} disabled={!permissions.canCancel || loading} className="p-2 bg-white border border-red-200 text-red-500 rounded-lg disabled:opacity-50"><MdCancel size={18} /></button>
                    </>
                )}
                {currentTab === 'inProgress' && order.status !== 'PROCESSINGPAYMENT' && (
                    <button onClick={() => onAction('deliver', order)} disabled={!permissions.canChange || loading} className="flex-1 bg-custom_blue hover:bg-blue-600 text-white py-2 rounded-lg font-bold text-xs flex items-center justify-center gap-1 transition-colors shadow-sm disabled:opacity-50">
                        <MdDeliveryDining size={18} /> Pronto p/ Entrega
                    </button>
                )}
                {order.status === 'PROCESSINGPAYMENT' && (
                    <div className="w-full flex items-center justify-between px-2 gap-2">
                        <span className="text-xs text-yellow-600 font-bold flex items-center gap-1 shrink-0">
                            <AiOutlineLoading className="animate-spin" /> Aguardando
                        </span>
                        <div className="flex items-center gap-3">
                            <button
                                onClick={() => onAction('confirmPayment', order)}
                                disabled={!permissions.canChange || loading}
                                className="text-xs text-green-600 underline font-bold disabled:opacity-50 disabled:cursor-not-allowed whitespace-nowrap"
                            >
                                Confirmar Pgto
                            </button>
                            <button
                                onClick={() => onAction('cancel', order)}
                                disabled={!permissions.canCancel || loading}
                                className="text-xs text-red-500 underline font-bold disabled:opacity-50 disabled:cursor-not-allowed"
                            >
                                Cancelar
                            </button>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};